import {Injectable} from '@angular/core';
import {VwLabBonusContinua} from '../../../models/vwLabBonusContinua';
import { VwLabBonusContinuaGuest } from 'src/app/models/VwLabBonusContinuaGuest';

@Injectable({
  providedIn: 'root'
})
export class BonusContinuaStore {
  title = 'Bonus Continua';
  viewAllPath = '/menu/viewall/bonusContinua';

  showLoader: boolean;

  records: VwLabBonusContinua[];
  sortedRecords: VwLabBonusContinua[];
  totalRecords: number;
 // isGuest:boolean=true;
  recordsGuest: VwLabBonusContinuaGuest[];
  sortedRecordsGuest: VwLabBonusContinuaGuest[];

  constructor() {
    this.records = [];
    this.sortedRecords = [];
  }

  load(records: VwLabBonusContinua[]) {
    // TODO: sorting here
    this.records = records;
    this.sortedRecords = this.records.slice();
  }

  loadGuest(records: VwLabBonusContinuaGuest[]) {
    // TODO: sorting here
    this.recordsGuest = records;
    this.sortedRecordsGuest = this.recordsGuest.slice();
  }
}
